













import Vue from "vue";
import Component from "vue-class-component";
import PopularProducts from "../components/popularProducts/popularProducts.vue";
import CzButton from "../components/cz/CzButton.vue";
import CzPage from "../components/cz/CzPage.vue";
import CzStatus from "../components/cz/CzStatus.vue";
import {
  notifyPayment,
  isRedsysPopup,
  notifyOpenerPaymentAndClose,
} from "../core/embed";

@Component({
  components: { CzButton, CzPage, CzStatus, PopularProducts },
})
export default class PaymentKoPage extends Vue {
  error: string = "";

  async mounted() {
    // Popup de Redsys (embebido): avisa al iframe que lo abrió y se cierra; no renderiza.
    if (isRedsysPopup()) {
      notifyOpenerPaymentAndClose("ko", this.$route.query.id);
      return;
    }
    // setTimeout(function () {
    //   window.scrollTo(0, 0);
    // }, 500);
    // new ShopService().removeCart();
    notifyPayment("ko");
  }
}
